/*
NOTE: If you are using a react component, you should be using the useFlags hook to get the flags via:
import { useFlags } from 'gatsby-plugin-launchdarkly'
*/

import LDClient, { LDContext } from 'launchdarkly-js-client-sdk'

const context: LDContext = {
  kind: 'user',
  anonymous: true
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const launchDarklyJsClient = LDClient.initialize(process.env.GATSBY_LD_CLIENT_ID!, context)

export default launchDarklyJsClient
